import {type MediaBrowserPanelConfig} from '../common';
import {type MediaHistorySpec} from './types';

export function getPanelMediaKeys(config: MediaBrowserPanelConfig): string[] {
  return config.mediaKeys ?? [];
}

export function getNoRequiredRunNames(): string[] {
  return [];
}

export function shouldAlwaysFilterRunsInQuery(): boolean {
  return true;
}

export function getCombinedHistorySpecs(
  config: MediaBrowserPanelConfig,
  mediaSliderKey: string,
  samples: number
): MediaHistorySpec[] | undefined {
  const mediaKeys = config.mediaKeys;
  if (mediaKeys == null || mediaKeys.length === 0) {
    return undefined;
  }

  return [
    {
      keys: [...new Set(['_step', mediaSliderKey, ...mediaKeys])],
      samples,
    },
  ];
}
